import TextViewer from './TextViewer';
import CardViewer from './CardViewer';
import { lazyView } from '../lazyView';

// The game and simulator pull in their engines; load them only when a station uses one.
const SimulatorViewer = lazyView(() => import('./SimulatorViewer'));
const GameViewer = lazyView(() => import('./GameViewer'));

const viewers = {
  text: TextViewer,
  simulator: SimulatorViewer,
  game: GameViewer,
  card: CardViewer,     // gallery-fit-content: single latest card, auto-sizes (no fillHeight)
};

// gallery-fit-content: viewers that stretch the card to fill a fixed box (games/canvas). An embed
// under one of these keeps the fixed-height layout; any OTHER viewer is content-fit + height-beacon.
export const FILL_VIEWERS = new Set(['game', 'simulator']);

export function registerViewer(name, component) {
  viewers[name] = component;
}

export function getViewer(name) {
  return viewers[name] || TextViewer;
}
